import { render, staticRenderFns } from "./OrderPay.vue?vue&type=template&id=0c4de414&scoped=true"
import script from "./OrderPay.vue?vue&type=script&lang=js"
export * from "./OrderPay.vue?vue&type=script&lang=js"
import style0 from "./OrderPay.vue?vue&type=style&index=0&id=0c4de414&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4de414",
  null
  
)

export default component.exports